export const showTab = (data,headIndexs,index) =>{
    data.navIndex = headIndexs
    data.navSonIndex = index
}
export const tagChage = (item,ctx) =>{
    ctx.emit('menuChange',item)
}